import { Component, OnInit, Input } from '@angular/core';
import { ToasterModule, ToasterService, Toast } from 'angular5-toaster';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CatalogsService } from '../../services/catalogs/catalogs.service';
import { AddRegComponent } from '../../components/add-reg/add-reg.component';
import { GeneralService } from './../../services/admin/general.service';
import { StorageService } from '../../services/storage.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-exchange',
  templateUrl: './exchange.component.html',
  styleUrls: ['./exchange.component.scss'],
  providers: [GeneralService]
})
export class ExchangeComponent implements OnInit {
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  rows = [];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  rows_monedas = [];
  rows_homologacion = [];
  selected = [];
  modalRespuesta;
  closeResult = '';
  titulo;
  mensaje;
  busy = false;

  toastRegistroDe;
  monedaEliminada;
  errorEliminarMoneda;
  homologacionMoneda;
  errorEliminarHomologacion;
  constructor(
    private translate: TranslateService,
    private general: GeneralService,
    private modalService: NgbModal,
    private toasterService: ToasterService,
    private catalogService: CatalogsService,
    private storageService: StorageService

  ) {
    setTimeout(() => { this.loadingIndicator = false; }, 1500);
    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });

    this.translate.get('texto.toastRegistroDe').subscribe(
      text => {
        this.toastRegistroDe = text;
      });

    this.translate.get('texto.monedaEliminada').subscribe(
      text => {
        this.monedaEliminada = text;
      });

    this.translate.get('texto.errorEliminarMoneda').subscribe(
      text => {
        this.errorEliminarMoneda = text;
      });

    this.translate.get('texto.homologacionEliminada').subscribe(
      text => {
        this.homologacionMoneda = text;
      });

    this.translate.get('texto.errorEliminarHomologacion').subscribe(
      text => {
        this.errorEliminarHomologacion = text;
      });
  }

  ngOnInit() {
    this.noBack();
    this.modulo();
    this.getCatalogoMonedas();
    this.getCatalogoHomologacion();
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.general.serviceLog('Cambio moneda').subscribe(
      data => {
        // console.log(data);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  getCatalogoMonedas() {
    this.catalogService.listarMonedas().subscribe(
      data => this.populateTableM(data.moneda),
      err => {
        // console.log(err);
      },
    );
  }

  private populateTableM(data) {
    if (data.length > 0) {
      this.rows_monedas = data;
    }
  }

  private populateTableHM(data) {
    if (data.length > 0) {
      this.rows_homologacion = data;
    }
  }

  addReg(tipo: string) {
    const modalRef = this.modalService.open(AddRegComponent, { size: 'sm', centered: true, backdrop: 'static', keyboard: false });
    modalRef.result.then(
      (result) => {
        if (result !== 'x') {
          if (result.estatus === 'S') {

            this.toasterService.pop('success', '', result.mensaje);
            if (tipo === 'moneda') {
              this.getCatalogoMonedas();
            } else {
              this.getCatalogoHomologacion();
            }

          } else if (result.estatus !== 'S') {
            this.toasterService.pop('error', 'Error', result.mensaje);
          }
        }
      }
    )

    modalRef.componentInstance.modulo = tipo;
  }


  getCatalogoHomologacion() {
    this.catalogService.listarHomologacion().subscribe(
      data => this.populateTableHM(data.homologacionMoneda),
      error => console.log(error)//
    );
  }



  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }


  private deleteEntry(index, respuesta) {
    this.busy = true;
    let idHm = this.rows_monedas[index].idMoneda;
    this.catalogService.eliminarMoneda(idHm).subscribe(
      data => {
        this.busy = false;
        const status = data.result.estatus;
        this.mensaje = data.result.mensaje;
        if (status === 'S') {
          this.titulo = this.monedaEliminada;
          this.rows_monedas = [];
          this.catalogService.listarMonedas().subscribe(
            data => this.populateTableM(data.moneda),
            error => console.log(error)//
          );
          this.toasterService.pop('success', '', this.mensaje);
        } else {
          this.busy = false;
          this.titulo = this.errorEliminarMoneda;
          this.toasterService.pop('error', 'Error', this.mensaje);
        }
        // this.openMensaje(respuesta);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } else {
          this.toasterService.pop('error', 'Error', err.message);
        }
      },
    );
  }


  private deleteHM(index, respuesta) {
    this.busy = true;
    const idHm = this.rows_homologacion[index].idHomologacion;
    this.catalogService.eliminarHomologacion(idHm).subscribe(
      data => {
        this.busy = false;
        const status = data.result.estatus;
        this.mensaje = data.result.mensaje;
        if (status === 'S') {
          this.titulo = this.homologacionMoneda;
          this.rows_homologacion = [];
          this.catalogService.listarHomologacion().subscribe(
            data => this.populateTableHM(data.homologacionMoneda),
            error => console.log(error)//
          );
          this.toasterService.pop('success', '', this.mensaje);
        } else {
          this.busy = false;
          this.titulo = this.errorEliminarHomologacion;
          this.toasterService.pop('error', 'Error', this.mensaje);
        }
        // this.openMensaje(respuesta);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } else {
          this.toasterService.pop('error', 'Error', err.message);
        }
      },
    );

  }



  openMensaje(respuesta) {
    this.modalRespuesta = this.modalService.open(respuesta, { centered: true });
    this.modalRespuesta.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
    });
  }

  private getDismissReasonFiltersOC(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/pages/exchange/exchange.component.ts